module.exports = __webpack_public_path__ + "app-static/img/btn1.973b918c.png";